import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTicketsReport = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 33 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M7 14H18",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 19H13",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 24.0146H11",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 31.0146H3C1.89543 31.0146 1 30.1192 1 29.0146V8.01465C1 6.91008 1.89543 6.01465 3 6.01465H8C8 3.25322 10.2386 1.01465 13 1.01465C15.7614 1.01465 18 3.25322 18 6.01465H23C24.1046 6.01465 25 6.91008 25 8.01465V11.0146",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 5.01465C13.2761 5.01465 13.5 5.23851 13.5 5.51465C13.5 5.79079 13.2761 6.01465 13 6.01465C12.7239 6.01465 12.5 5.79079 12.5 5.51465C12.5 5.23851 12.7239 5.01465 13 5.01465",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M23.6528 30.4C23.8692 30.5543 24.1654 30.5292 24.3528 30.3407L31.3401 23.3527C31.5284 23.1652 31.5535 22.8692 31.3994 22.6527C30.7288 21.709 30.7288 20.4444 31.3994 19.5007C31.5541 19.2842 31.529 18.9874 31.3401 18.8L28.2001 15.6594C28.0125 15.4704 27.7155 15.4452 27.4988 15.6C26.5553 16.2703 25.291 16.2703 24.3474 15.6C24.1309 15.4463 23.835 15.4714 23.6474 15.6594L16.6601 22.6474C16.4719 22.8348 16.4465 23.1307 16.6001 23.3474C17.2707 24.291 17.2707 25.5557 16.6001 26.4994C16.4456 26.716 16.471 27.0128 16.6601 27.2L19.8001 30.3407C19.9878 30.5288 20.284 30.5533 20.5001 30.3987C21.4442 29.7282 22.7093 29.7287 23.6528 30.4Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M23.6777 18.7062C24.0682 18.3157 24.7014 18.3157 25.0919 18.7062L28.2937 21.908C28.6842 22.2985 28.6842 22.9317 28.2937 23.3222L24.3226 27.2933C23.9321 27.6838 23.2989 27.6838 22.9084 27.2933L19.7066 24.0915C19.3161 23.701 19.3161 23.0678 19.7066 22.6773L23.6777 18.7062Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.3847 21.0767L22.0767 23.3847",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.1861 23.3527L24.4674 24.0714",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgTicketsReport);
export default ForwardRef;
